export class TranslationKey {
  public static readonly NewAppointment: string = 'NewAppointment';
  public static readonly Rescheduled: string = 'Rescheduled';
  public static readonly StatusChanged: string = 'StatusChanged';

  public static readonly NewUnavailableSlot: string = 'NewUnavailableSlot';
  public static readonly UnavailableSlotUpdated: string = 'UnavailableSlotUpdated';
  public static readonly UnavailableSlotRemoved: string = 'UnavailableSlotRemoved';

  public static readonly OrderConfirmed: string = 'OrderConfirmed';
  public static readonly OrderShipped: string = 'OrderShipped';
  public static readonly OrderRejected: string = 'OrderRejected';
}
